(function DigitalFileModuleDefinition() {
    'use strict';

    angular.module('DigitalFile', ['ui.router', 'Config', 'Entities', 'ErrorsExtend'])
        .config(['configProvider', '$stateProvider', 'loginProvider',
            function statusConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('digital-file-template', {
                    url: "/template/",
                    templateUrl: config.resourceUrl('/views/digital-file/digital-file-template.html'),
                    controller: 'DigitalFileTemplateController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ASOCIATETCDIGITALFILE')
                });
            }
        ]);
})();